<template>
    <path d="M2.9 18.07v-3.03l.98-.97.97-.97v4.54l2.24-2.23 2.23-2.23.75.75.75.75-2.19 2.2-2.2 2.19h4.47l-1 1.01-1.02 1.02H2.9zm11.17 2.05l-.97-.97h4.54l-2.23-2.24-2.23-2.23.75-.75.75-.75 2.2 2.19 2.19 2.2V13.1l1.01 1.01 1.02 1.01v5.98h-6.06zM3.9 9.87l-1-1V2.9h6.06l.97.98.97.97H6.36L8.59 7.1l2.23 2.23-.75.75-.75.75-2.2-2.19-2.18-2.19-.02 2.21-.03 2.22zm15.25-1.24V6.36L16.9 8.59l-2.23 2.23-.75-.75-.75-.75 2.19-2.2 2.2-2.19H13.1l1.01-1.01 1.01-1.02h5.98v6.06l-.98.97-.97.97z"/>
</template>

<script>
    export default {
        name: 'zoom-out',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/ZoomOut.vue